import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import Sidebar from "../../components/Sidebar";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as companyActions from "../../redux/actions/companyAction";
import { setLanguage } from "redux-i18n";
import PropTypes from "prop-types";
import CompanyComponent from "../../components/Company";

const CompanySetup = (props,context) => {
  const commonReducer = useSelector((state) => state.commonReducer);
  const companyReducer = useSelector((state) => state.companyReducer);
  const profileReducer = useSelector((state) => state.profileReducer);

  const dispatch = useDispatch();
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const companyAction = bindActionCreators(companyActions, dispatch);

  // Step Action

  const setMaximumFormStep = (maxCount) => {
    companyAction.setMaximumFormStep(maxCount);
  };

  const setMinimumFormStep = (minCount) => {
    companyAction.setMinimumFormStep(minCount);
  };
  const setCurrentFormStep = (stepCount) => {
    companyAction.setCurrentFormStep(stepCount);
  };

  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };
  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };
  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <CompanyComponent
          stepCount={companyReducer.step}
          maxStep={companyReducer.maxSteps}
          minStep={companyReducer.minSteps}
          setMaxStep={setMaximumFormStep}
          setMinStep={setMinimumFormStep}
          setCurrentFormStep={setCurrentFormStep}
        />
      </div>
    </>
  );
};

CompanySetup.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CompanySetup;
